<app-filter
  [fields]="filterFields"
  [panelTitle]="'Filter Account Manager Contacts'"
  (apply)="applyFilters($event)"
  (clear)="resetFilters()">
</app-filter>
<div class="d-flex justify-content-end mb-3">
      <p-button
      label="Add Contact"
      [link]="true"
      icon="pi pi-plus-circle"
  (click)="onOpenAddContactDialog()"
      styleClass="px-0"
      class="me-2"
    />  
  <!-- <p-button
      label="Delete Contact"
      [link]="true"
      icon="pi pi-trash"
      styleClass="px-0"
    /> -->
</div>
<!-- <app-list [data]="contacts"
  [totalRecords]="totalRecords"
  [loading]="loading"
  [tableParams]="tableParams"
  [columns]="columns"
  (pageChange)="onPageChange($event)"
  (sortChange)="onSortChange($event)"
></app-list> -->
<app-loader></app-loader>
<app-list 
  [columns]="columns" 
  [data]="contacts" 
  [rows]="10"
  [rowsPerPageOptions]="[10, 25, 50]" 
  (nameClick)="onContactNameClick($event)">
</app-list>
<!-- Add contact modal -->
<!-- <app-modal [header]="'Add contact'" [(showDialog)]="showAddContactModal" [rejectLabel]="'Cancel'" [acceptLabel]="'Save and Add More'" [saveLabel]="'Save'"
    (acceptModalClick)="onAddContact()" (rejectModalClick)="onCancelForm()" (saveModalClick)="onSaveAndAddContact()"> -->
<p-dialog header="{{addContactHeader}}" [(visible)]="visible" [modal]="true" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '50vw', height: '500px' }" [draggable]="false" [resizable]="false" closeAriaLabel="Close dialog" (onHide)="onDialogHide()">
  <app-add-contact 
    #addContactComp
    [fieldLabels]="customLabels"
    [fieldVisibility]="customVisibility"
    [fieldPlaceholders]="customPlaceholders"
    [sourceComponent]="'account-contacts'"
    [titles]="titles"
    [accountNames]="accountNames"
    [statuses]="statuses">
  </app-add-contact>

  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2">
      <p-button 
        label="Cancel" 
        class="me-2"
        (onClick)="onCancelForm()"
        styleClass="p-button-secondary">
      </p-button>

      <p-button *ngIf="isEditModeEnabled"
        label="Update" 
        class="me-2"
        (onClick)="onUpdateContact()"
        styleClass="p-button-primary">
      </p-button>
      
      <p-button *ngIf="!isEditModeEnabled"
        label="Save" 
        class="me-2"
        (onClick)="onAddContact()"
        styleClass="p-button-primary">
      </p-button>
      
      <p-button *ngIf="!isEditModeEnabled"
        label="Save & Add More"
        (onClick)="onSaveAndAddContact()"
        styleClass="p-button-primary">
      </p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- </app-modal> -->